<div>
  <div *ngIf="label" class="flex justify-start items-center space-x-1 mb-2">
    <span *ngIf="required" class="text-lg text-red-500 font-bold mr-1">*</span>
    <label for="{{ controlName }}" class="text-sm font-medium text-gray-700 dark:text-primary-100">{{ label }}</label>
  </div>

  <div class="relative">
    <input
      id="{{ controlName }}"
      type="text"
      class="combobox-multiselect"
      autocomplete="off"
      [attr.aria-expanded]="isOpen"
      [placeholder]="placeholder"
      (input)="onSearchTermChange($event)"
      (click)="toggleDropdown($event)"
      [value]="searchTerm"
    />
    <button
      type="button"
      class="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none"
      (click)="toggleDropdown($event)">
      <svg class="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path
          fill-rule="evenodd"
          d="M10 3a.75.75 0 01.55.24l3.25 3.5a.75.75 0 11-1.1 1.02L10 4.852 7.3 7.76a.75.75 0 01-1.1-1.02l3.25-3.5A.75.75 0 0110 3zm-3.76 9.2a.75.75 0 011.06.04l2.7 2.908 2.7-2.908a.75.75 0 111.1 1.02l-3.25 3.5a.75.75 0 01-1.1 0l-3.25-3.5a.75.75 0 01.04-1.06z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <ul
      *ngIf="isOpen"
      class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
      id="options"
      role="listbox"
    >
      <li
        *ngFor="let option of filteredOptions"
        class="relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900"
        (click)="toggleSelection(option)"
        role="option"
      >
        <div class="flex items-center">
          <input
            *ngIf="option[valueKey] !== null"
          type="checkbox"
          class="form-checkbox h-4 w-4 text-primary border-gray-300 rounded"
          [checked]="isSelected(option)"
          (click)="$event.stopPropagation()"
          (change)="toggleSelection(option)"
          />
          <span class="ml-3 block truncate">{{ option[displayKey] }}</span>
        </div>
      </li>
    </ul>

    <div *ngIf="showIcon" class="hidden md:block absolute top-1/2 -translate-y-1/2" style="right: -30px;">
      <svg *ngIf="hasValue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-6 stroke-2 text-green-500">
        <path fill-rule="evenodd" d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z" clip-rule="evenodd" />
      </svg>
      <svg *ngIf="!hasValue" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="size-6 text-amber-500">
        <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
      </svg>
    </div>

  </div>

  <!-- Validation error message -->
  <div class="pt-1" *ngIf="formControl.touched && formControl.invalid">
    <div class="ng-invalid input-error" *ngIf="formControl.errors?.['required']">
      {{ label }} field is required.
    </div>
  </div>

  <!-- Selected options pills -->
  <div class="-m-1 flex flex-wrap items-center mt-2">
    <span *ngFor="let option of selectedOptions" class="m-1 inline-flex items-center rounded-full border border-gray-200 bg-white py-1.5 pl-3 pr-2 text-xs font-medium text-gray-900">
      <span>{{ option[displayKey] }}</span>
      <button type="button" class="ml-1 inline-flex h-4 w-4 flex-shrink-0 rounded-full p-1 text-gray-400 hover:bg-gray-200 hover:text-gray-500" (click)="removeSelectedOption(option)">
        <span class="sr-only">Remove {{ option[displayKey] }}</span>
        <svg class="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
          <path stroke-linecap="round" stroke-width="1.5" d="M1 1l6 6m0-6L1 7" />
        </svg>
      </button>
    </span>
  </div>

</div>
